<template>
    <div>
        <h1 class="display-heading">Add Company Users</h1>

        <!-- <div class="mb-5">
            <h5 class="mb-3">Bulk Add Users</h5>
            <div class="card">
                <div class="card-body">
                    <p>Upload an excel / csv file containing all users details. (Function Not Ready)</p>
                    <div class="form-group">
                        <input type="file" />
                    </div>
                    <button class="btn btn-primary btn-primary-insv">Upload And Add Users</button>
                </div>
            </div>
        </div> -->

        <div>
            <h5 class="mb-3">Add User Manually</h5>
            <div class="card">
                <div class="card-body">
                    <div class="form-group">
                        <form @submit.prevent="addCompanyUser">
                            <div class="form-group">
                                <label>Full Name</label>
                                <input type="text" class="form-control" placeholder="Staff Name" v-model="form.fullName">
                            </div>
                            <!-- <div class="form-group">
                                <label>IC Number</label>
                                <input type="text" class="form-control" placeholder="IC Number">
                            </div> -->
                            <div class="form-group">
                                <label>Email Address</label>
                                <input type="text" class="form-control" placeholder="Email Address" v-model="form.emailAddress">
                            </div>
                            <div class="form-group">
                                <label>Phone Number</label>
                                <input type="text" class="form-control" placeholder="Phone Number" v-model="form.phoneNumber">
                            </div>
                            <div class="form-group">
                                <label>Create a New Password</label>
                                <input type="password" class="form-control" placeholder="Password" v-model="form.password">
                            </div>
                            <div class="form-group">
                                <label>Re-type Password</label>
                                <input type="password" class="form-control" placeholder="Re-type Password" v-model="form.retypePassword">
                            </div>
                            <div v-show="addUserMessage!=null" :class="[
                                'mb-3',
                                {
                                    'text-danger': addUserError,
                                    'text-primary': !addUserError
                                }
                                ]">
                                {{addUserMessage}}
                            </div>
                            <button class="btn btn-primary btn-primary-insv">Add User</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            'addUserMessage': null,
            'addUserError': false,
            'form': {
                'fullName': null,
                'emailAddress': null,
                'phoneNumber': null,
                'password': null,
                'retypePassword': null
            }
        };
    },
    'methods': {
        addCompanyUser () {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.addUserMessage = 'Adding new company user...';
                    this.addUserError = false;

                    this.axios.post('Account/Register/User', {
                        'f': this.form.fullName,
                        'e': this.form.emailAddress,
                        'pn': this.form.phoneNumber,
                        'p': this.form.password
                    }).then(() => {
                        this.addUserMessage = 'Company user added!';

                        this.form.fullName = null;
                        this.form.emailAddress = null;
                        this.form.phoneNumber = null;
                        this.form.password = null;
                        this.form.retypePassword = null;
                    }).catch(({ response }) => {
                        let responseData = response.data;

                        this.addUserError = true;
                        this.addUserMessage = responseData.message;
                    });
                    // this.axios.post('company/update', {
                    //     'i': this.companyId,
                    //     'n': this.companyName,
                    //     'r': this.companyRegistrationId,
                    //     'e': this.emailAddress,
                    //     'p': this.phoneNumber,
                    //     'cn': this.contactPerson
                    // }).then(() => {
                    //     this.updateMessage = 'Company profile successfully saved!';
                    // }).catch((error) => {
                    //     this.$store.commit('clearUserState');
                    //     this.$store.commit('setAppStatus', true);

                    //     let responseData = error.response ? error.response.data : null;

                    //     if (responseData) {
                    //         this.updateHasError = true;
                    //         this.updateMessage = responseData.message;
                    //     }
                    // });
                } else {
                    this.$nextTick(() => {
                        let errorDoms = document.querySelectorAll('.is-invalid');

                        if (errorDoms) {
                            errorDoms[0].focus();
                        }
                    });
                }
            });
        }
    }
};

</script>

<style>

</style>
